import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07013222"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "config-member" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "header__title" }, "添加成员", -1))
const _hoisted_4 = { class: "main" }
const _hoisted_5 = { class: "footer" }
const _hoisted_6 = { class: "footer__button" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("暂不添加")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("完成添加")


const __default__ = {
  name: 'ConfigMembers'
}

import { ref, toRefs } from 'vue'
import AddMember from './addMember.vue'
import { useTemplateRefsList } from '@vueuse/core'
import { AddTeamMember } from '@teams/common/api'
import { useMessage } from 'naive-ui'
import Icon from '@teams/common/components/icon'
import { useSingleGroupMemento } from '@teams/common/hooks/useMemento/group'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/store/user'
import { useGroupStore } from '@/store/group'
import { useNavigatorStore } from '@/store/navigator'
import { Member, RoleType, UserRoleIdsType } from '../type'
import handleResponseError from '@teams/common/hooks/useResponseError'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    groupId: null,
    roleList: null,
    closeAll: null
  },
  setup(__props: any) {

const props = __props as {
  groupId: number
  roleList: RoleType[]
  closeAll: (...payload: unknown[]) => unknown
}



const groupStore = useGroupStore()
const navigatorStore = useNavigatorStore()
const router = useRouter()
const singleGroupMemento = useSingleGroupMemento()
const { groupId, roleList } = toRefs(props)
const allUserIds = ref<number[]>([]) // all已选中联系人
const message = useMessage()
const addMemberButtonLoading = ref<boolean>(false)
const addMemberRefs = useTemplateRefsList<{ userRoleIds: UserRoleIdsType }>()
// 添加已选联系人
const selectedMember = (info: Member[]) => {
  allUserIds.value = [...allUserIds.value, ...info.map(item => item.userId)]
}

// 取消添加单个成员in allUserIds
const cancelOneUser = (userId: number) => {
  allUserIds.value = allUserIds.value.filter(item => item !== userId)
}
// 确认添加成员
const confirmAdd = async () => {
  addMemberButtonLoading.value = true
  const userRoleList: UserRoleIdsType[] = addMemberRefs.value.map(
    item => item.userRoleIds
  )
  try {
    await AddTeamMember(groupId.value, allUserIds.value, userRoleList)
    enterGroup()
  } catch (e: any) {
    addMemberButtonLoading.value = false
    handleResponseError(e)
  }
}
const changeGroup = async (groupId: number) => {
  try {
    const userStore = useUserStore()
    await singleGroupMemento.originator.changeState(() => ({
      groupId: groupId,
      userId: userStore.userId as number,
      shouldFlushStore: true,
      shouldFlushUsePreference: true,
      shouldFlushUseTeamShare: true
    }))
    await singleGroupMemento.changeGroup(groupId)
    const nav = navigatorStore.list?.[0]
    // 直接push不需要刷新即可完成首次进入团队
    router.push({
      name: 'Nav',
      params: {
        groupId: groupId
      },
      query: { nid: nav.id }
    })
  } catch (error) {
    window.location.href = window.location.origin + `/${groupId}`
  }
}
// 访问团队
const enterGroup = async () => {
  addMemberButtonLoading.value = false
  message.success('空间创建成功')
  // 【不强制刷新界面进入新团队】
  // 判断团队是否创建成功, 暂时使用sessionStorage，后续需要改进
  props.closeAll()
  groupStore.reloadMyGroups()
  changeGroup(groupId.value)
}

return (_ctx: any,_cache: any) => {
  const _component_n_gi = _resolveComponent("n-gi")!
  const _component_n_grid = _resolveComponent("n-grid")!
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        onClick: enterGroup,
        class: "header__closeButton"
      }, [
        _createVNode(_unref(Icon), {
          size: 16,
          name: "close"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_n_grid, {
        "x-gap": "8",
        cols: _unref(roleList).length < 4 ? _unref(roleList).length : 3
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(roleList), (item) => {
            return (_openBlock(), _createBlock(_component_n_gi, {
              key: item.roleId
            }, {
              default: _withCtx(() => [
                _createVNode(AddMember, {
                  roleInfo: item,
                  onSelectedMember: selectedMember,
                  onCancelOneUser: cancelOneUser,
                  allUserIds: allUserIds.value,
                  ref_for: true,
                  ref: _unref(addMemberRefs).set
                }, null, 8, ["roleInfo", "allUserIds"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["cols"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (allUserIds.value.length === 0)
          ? (_openBlock(), _createBlock(_component_n_button, {
              key: 0,
              onClick: enterGroup
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_n_button, {
              key: 1,
              type: "warning",
              onClick: confirmAdd,
              loading: addMemberButtonLoading.value
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["loading"]))
      ])
    ])
  ]))
}
}

})